import { define } from '../../define.js';
import { DropdownLabel } from './dropdown-label.js';
export * from './dropdown-label.js';
define('dropdown-label', DropdownLabel);
